<template>
  <div>
    <b-tabs content-class="" fill v-model="tabIndex">
      <b-tab ref="item" data-key="item" :title="$t('item')">
        <SettingsItem />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SettingsItem from './SettingsItem.vue';

export default {
  name: 'Settings',
  components: {
    SettingsItem,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
};
</script>

<style scoped>
/* Component styles */
</style>
